var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "homeView", tag: "section" } },
    [
      _c("v-row", [_c("welcome-widget")], 1),
      _c("v-row", [_c("module-browser")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }